import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_SRC = '/brand/logo-oh-belleza.png';

export default function BrandLogo({ variant = 'header', light = false }) {
  return (
    <Link
      to="/"
      className={`store-logo store-logo-${variant}${light ? ' store-logo-light' : ''}`}
      aria-label="¡Oh! Belleza inicio"
    >
      <span className="store-logo-frame">
        <img src={LOGO_SRC} alt="¡Oh! Belleza" className="store-logo-img" />
      </span>
    </Link>
  );
}
